import React from 'react';
import { Form, Input, Select } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import { useSignUp } from '../context/SignUpContext';
import StepNavigation from '../components/StepNavigation';
import { bankOptions, filterBankOption } from '../../../../utils/bankList';

const StepBankAccount = () => {
  const [form] = Form.useForm();
  const { formData, updateBankAccount, nextStep, prevStep } = useSignUp();

  const handleNext = async () => {
    try {
      await form.validateFields();
      nextStep();
    } catch (err) {
      // Validation failed
    }
  };

  return (
    <div className="step-content">
      <div className="step-header">
        <h2>Conta bancária</h2>
        <p>Informe os dados da conta para receber seus pagamentos.</p>
      </div>

      <Form
        form={form}
        layout="vertical"
        initialValues={{
          code: formData.bank_account.code,
          agency: formData.bank_account.agency,
          number: formData.bank_account.number,
          type: formData.bank_account.type,
        }}
        requiredMark={false}
      >
        <Form.Item
          name="code"
          label="Banco"
          rules={[{ required: true, message: 'Selecione o banco' }]}
        >
          <Select
            placeholder="Selecione o banco"
            size="large"
            showSearch
            optionFilterProp="label"
            filterOption={filterBankOption}
            options={bankOptions}
            onChange={(value) => updateBankAccount('code', value)}
            suffixIcon={<BankOutlined />}
          />
        </Form.Item>

        <div className="form-row">
          <Form.Item
            name="agency"
            label="Agência"
            rules={[{ required: true, message: 'Digite a agência' }]}
            className="form-item-medium"
          >
            <Input
              placeholder="0001"
              size="large"
              onChange={(e) => updateBankAccount('agency', e.target.value)}
            />
          </Form.Item>

          <Form.Item
            name="number"
            label="Conta com dígito"
            rules={[{ required: true, message: 'Digite o número da conta' }]}
            className="form-item-medium"
          >
            <Input
              placeholder="12345-6"
              size="large"
              onChange={(e) => updateBankAccount('number', e.target.value)}
            />
          </Form.Item>
        </div>

        <Form.Item
          name="type"
          label="Tipo de conta"
          rules={[{ required: true, message: 'Selecione o tipo de conta' }]}
        >
          <Select
            placeholder="Selecione o tipo"
            size="large"
            onChange={(value) => updateBankAccount('type', value)}
          >
            <Select.Option value="CHECKING_ACCOUNT">Conta Corrente</Select.Option>
            <Select.Option value="SAVINGS_ACCOUNT">Conta Poupança</Select.Option>
          </Select>
        </Form.Item>

        <div className="bank-info-notice">
          <p>
            <strong>Importante:</strong> A conta bancária deve estar no nome do titular
            ({formData.accountType === 'SELLER_PJ' ? 'CNPJ da empresa' : 'CPF informado'}).
          </p>
        </div>
      </Form>

      <StepNavigation
        onNext={handleNext}
        onBack={prevStep}
      />
    </div>
  );
};

export default StepBankAccount;
